import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { checkEmptyFields } from '../utils';
import { SurveyNps } from 'angular-api-gateway/v1/model/surveyNps';
import { SendSurveyNPSResponse } from 'angular-api-gateway/v1/model/sendSurveyNPSResponse';

export function surveyGetHandler(data: SurveyNps): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.title,
        errorName: 'NpsTitleIsEmpty',
      },
      {
        fieldToCheck: data?.highRatingCommentTitle,
        errorName: 'NpsHighRatingCommentIsEmpty',
      },
      {
        fieldToCheck: data?.lowRatingCommentTitle,
        errorName: 'NpsLowRatingCommentIsEmpty',
      },
      {
        fieldToCheck: data?.mediumRatingCommentTitle,
        errorName: 'NpsMediumRatingCommentIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function surveySendResultHandler(data: SendSurveyNPSResponse): EventProperties {
  const fields = [
    {
      fieldToCheck: data?.success,
      errorName: 'NpsSendFeedbackIsEmpty',
    },
  ];

  return checkEmptyFields(fields);
}
